<div *ngIf="errorThrown; else isLoading">
  <!-- <p class="fs-12 text-gray">{{errorMessage || 'GLOBAL.ERRORS.COULD_NOT_LOAD' | translate}}</p> -->
  <!-- <p class="fs-12 text-gray">{{'GLOBAL.ERRORS.COULD_NOT_LOAD' | translate}}</p> -->

  <!-- <app-card-empty
    *ngIf="showBanner; else showMessage"
    [title]="'GLOBAL.ERRORS.SERVICE_ERROR' | translate"
    [subtitle]="'GLOBAL.ERRORS.COULD_NOT_LOAD' | translate"
    iconSvg="error-service.svg"
    [height]="errorContainerHeight">
  </app-card-empty>
  <ng-template #showMessage> -->
  <div class="message">{{errorMessage ? errorMessage : ('GLOBAL.ERRORS.SERVICE_ERROR' | translate)}}</div>
  <!-- </ng-template> -->
</div>
<ng-template #isLoading>
  <ng-content></ng-content>
</ng-template>
